import AppointmentsParticipant from "../../pages/participant/appointmentsParticipant";
import Booking from "../../pages/participant/booking/booking";
import WelcomeParticipant from "../../pages/participant/welcomeParticipant";
import WelcomeCoach from "../../pages/coach/welcomeCoach";
import SiteBanner from "../../components/siteBanner/siteBanner";
import Landingpage from "../../pages/landingpage";
import NotFound from "../../pages/notFound";
import SearchParticipantCoach from "../../pages/coach/searchParticipant";
import SearchParticipantAdmin from "../../pages/admin/searchParticipant";
import ChangePassword from "../../pages/changePassword";
import NewAppointmentCoach from "../../pages/coach/newAppointmen/newAppointment";
import AppointmentUpload from "../../pages/admin/appointmentUpload/appointmentUpload";
import Navigation from "../../pages/landingpage/navigation/navigation";
import Profile from "../../pages/profile/profile";
import React from "react";
import NewAppointment from "../../pages/admin/newAppointment";
import CoachList from "../../pages/admin/coachList";
import Analytics from "../../pages/admin/analytics";
import BookingOverview from "../../pages/admin/bookingOverview";
import RatingOverview from "../../pages/admin/ratingOverview";
import Dashboard from "../../pages/admin/dashboard";
import AppointmentOverview from "../../pages/admin/appointmentOverview";
import DayliPlan from "../../pages/coach/dayliPlan";
import ParticipantFiles from "../../pages/participant/participantFiles";
import WelcomeAdmin from "../../pages/admin/welcomeAdmin";

const routeError: React.JSX.Element = (
  <h2>Da ist etwas schiefgelaufen. Bitte versuche es später erneut.</h2>
);

export interface AppRoute {
  path: string;
  element: JSX.Element;
  errorElement: React.JSX.Element;
}

export interface AppRoutes {
  open: AppRoute[];
  participant: AppRoute[];
  coach: AppRoute[];
  admin: AppRoute[];
}

export const appRoutes: AppRoutes = {
  open: [
    {
      path: "/logout",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Logout"} />
        </React.Fragment>
      ),
      errorElement: routeError,
    },
    {
      path: "/",
      element: (
        <React.Fragment>
          <Navigation />
          <Landingpage />
        </React.Fragment>
      ),
      errorElement: routeError,
    },
    {
      path: "*",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Seite nicht gefunden"} />
          <NotFound />,
        </React.Fragment>
      ),
      errorElement: routeError,
    },
    {
      path: "/profile",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Profil"} />
          <Profile />
        </React.Fragment>
      ),
      errorElement: routeError,
    },
  ],
  participant: [
    {
      path: "/intern-participant",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Willkommen beim Bewerbungscoaching"} />
          <WelcomeParticipant />
        </React.Fragment>
      ),
      errorElement: routeError,
    },
    {
      path: "/change-password",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Passwort ändern"} />
          <ChangePassword />,
        </React.Fragment>
      ),
      errorElement: routeError,
    },
    {
      path: "/booking",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Termine buchen"} />
          <Booking />
        </React.Fragment>
      ),
      errorElement: routeError,
    },
    {
      path: "/appointments",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Meine Termine"} />
          <AppointmentsParticipant />
        </React.Fragment>
      ),
      errorElement: routeError,
    },
    {
      path: "/files",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Meine Unterlagen"} />
          <ParticipantFiles />
        </React.Fragment>
      ),
      errorElement: routeError,
    },
  ],
  coach: [
    {
      path: "/intern-coach",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Willkommen beim Bewerbungscoaching"} />
          <WelcomeCoach />
        </React.Fragment>
      ),
      errorElement: routeError,
    },
    {
      path: "daily-plan",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Tagesplan"} />
          <DayliPlan />
        </React.Fragment>
      ),
      errorElement: routeError,
    },
    {
      path: "search-participant-coach",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Teilnehmersuche"} />
          <SearchParticipantCoach />
        </React.Fragment>
      ),
      errorElement: routeError,
    },
    {
      path: "new-appointment-coach",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Termin erstellen"} />
          <NewAppointmentCoach />
        </React.Fragment>
      ),
      errorElement: routeError,
    },
    {
      path: "/appointment-overview-coach",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Terminübersicht"} />
          <AppointmentOverview />
        </React.Fragment>
      ),
      errorElement: routeError,
    },

    {
      path: "/change-password",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Passwort ändern"} />
          <ChangePassword />,
        </React.Fragment>
      ),
      errorElement: routeError,
    },
  ],
  admin: [
    {
      path: "/intern-admin",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Willkommen beim Bewerbungscoaching"} />
          <WelcomeAdmin />
        </React.Fragment>
      ),
      errorElement: routeError,
    },

    {
      path: "/dashboard",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Dashboard"} />
          <Dashboard />
        </React.Fragment>
      ),
      errorElement: routeError,
    },
    {
      path: "/booking-overview",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Buchungsübersicht"} />
          <BookingOverview />
        </React.Fragment>
      ),
      errorElement: routeError,
    },
    {
      path: "/appointment-overview-admin",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Terminübersicht"} />
          <AppointmentOverview />
        </React.Fragment>
      ),
      errorElement: routeError,
    },
    {
      path: "/change-password",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Passwort ändern"} />
          <ChangePassword />,
        </React.Fragment>
      ),
      errorElement: routeError,
    },
    {
      path: "/new-appointment-admin",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Termine erstellen"} />
          <NewAppointment />
        </React.Fragment>
      ),
      errorElement: routeError,
    },
    {
      path: "/new-appointment-upload",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Termin upload"} />
          <AppointmentUpload />
        </React.Fragment>
      ),
      errorElement: routeError,
    },
    {
      path: "/search-participant-admin",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Teilnehmersuche"} />
          <SearchParticipantAdmin />
        </React.Fragment>
      ),
      errorElement: routeError,
    },
    {
      path: "/coachlist",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Nutzerverwaltung"} />
          <CoachList />
        </React.Fragment>
      ),
      errorElement: routeError,
    },
    {
      path: "/analytics",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Auswertung"} />
          <Analytics />
        </React.Fragment>
      ),
      errorElement: routeError,
    },
    {
      path: "/ratingOverview",
      element: (
        <React.Fragment>
          <Navigation />
          <SiteBanner title={"Bewertungen"} />
          <RatingOverview />
        </React.Fragment>
      ),
      errorElement: routeError,
    },
  ],
};
